import { useState } from "react";
import { FaEllipsisV } from "react-icons/fa";
import StatChips from "./StatChips";
import { getStatColorTokens } from "./statColors";

export default function PageHeader({
  icon: Icon,
  iconColor = "indigo",
  title,
  subtitle,
  stats = [],
  actions = [],
  isLoading = false,
  mobileSlotId,
  /** İstatistiklerin SOLUNA yerleşen serbest içerik (ör. fabrika krokisinin
   *  araç çubuğu). Verilmezse hiç render edilmez; mevcut sayfalar etkilenmez. */
  slot = null,
}) {
  const ic = getStatColorTokens(iconColor);
  // Mobilde aksiyonlar tek ⋮ menüsünde toplanır (aksiyon yoksa menü de yok)
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex items-center gap-3 sm:gap-4">
      {/* Title — başlık/ikon verilmezse hiç render edilmez. Sekmeli sayfalarda
          (ör. Ödemeler) başlık üstte bir kez durur, sekme içeriği yalnızca
          kendi istatistik şeridini basar; boş bir <h1> yer kaplamasın. */}
      {(Icon || title) && (
        <div className="flex items-center gap-2 shrink-0">
          {Icon && (
            <div
              className={`p-1.5 sm:p-2 bg-gradient-to-br ${ic.gradient} rounded-lg sm:rounded-xl shadow-sm border ${ic.border}`}
            >
              <Icon className={`${ic.icon} w-4 h-4 sm:w-5 sm:h-5`} />
            </div>
          )}
          <div>
            <h1 className="text-sm sm:text-lg font-bold text-gray-900 whitespace-nowrap">
              {title}
            </h1>
            {subtitle && (
              <p className="text-[10px] sm:text-xs text-gray-500 hidden sm:block">
                {subtitle}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Stats + Actions */}
      <div className="flex items-center gap-1.5 sm:gap-2.5 flex-1 justify-end flex-wrap">
        {slot}
        <StatChips stats={stats} isLoading={isLoading} />

        {/* Masaüstü: aksiyon butonları */}
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={action.onClick}
            disabled={action.disabled || isLoading}
            title={action.label}
            className={`hidden sm:flex items-center gap-2 px-3.5 py-2 font-semibold rounded-lg shadow-sm hover:shadow-md transition-all duration-200 text-sm ${
              action.variant === "primary"
                ? "bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white"
                : action.variant === "success"
                  ? "bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white"
                  : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
            }`}
          >
            {action.icon && <action.icon className="w-4 h-4" />}
            <span>{action.label}</span>
          </button>
        ))}

        {/* Mobil slot — başka bir bileşen (ör. ListToolbar filtre ikonu)
            buraya portal ile buton yerleştirebilir; ⋮'nın solunda durur. */}
        {mobileSlotId && (
          <span id={mobileSlotId} className="sm:hidden flex items-center gap-1.5" />
        )}

        {/* Mobil: tüm aksiyonlar sağ üstte tek ⋮ menüsünde */}
        {actions.length > 0 && (
          <div className="relative sm:hidden shrink-0">
            <button
              onClick={() => setMenuOpen((v) => !v)}
              className="flex items-center justify-center w-9 h-9 rounded-lg bg-white border border-gray-300 text-gray-600 shadow-sm active:bg-gray-100 transition-colors"
              title="İşlemler"
            >
              <FaEllipsisV className="w-4 h-4" />
            </button>
            {menuOpen && (
              <>
                <div className="fixed inset-0 z-30" onClick={() => setMenuOpen(false)} />
                <div className="absolute right-0 top-full mt-2 z-40 w-52 bg-white rounded-xl border border-gray-200 shadow-lg overflow-hidden p-1.5 space-y-1">
                  {actions.map((action) => (
                    <button
                      key={action.label}
                      onClick={() => {
                        setMenuOpen(false);
                        action.onClick();
                      }}
                      disabled={action.disabled || isLoading}
                      className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium text-left transition-colors disabled:opacity-50 ${
                        action.variant === "primary"
                          ? "text-indigo-700 bg-indigo-50 hover:bg-indigo-100"
                          : action.variant === "success"
                            ? "text-emerald-700 bg-emerald-50 hover:bg-emerald-100"
                            : "text-gray-700 bg-gray-50 hover:bg-gray-100"
                      }`}
                    >
                      {action.icon && <action.icon className="w-4 h-4 shrink-0" />}
                      <span>{action.label}</span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
